
import { defineComponent } from "vue";
import BackButton from "@/components/BackButton.vue";

export default defineComponent({
  name: "UnderConstruction",
  components: { BackButton },
  //   setup() {},
});
